module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid15_980x800.071b55b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid15_980x800.jpg
// module id = LA2R
// module chunks = 0